import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import styles from './marker.css'

const Marker = ({ animated }) =>
  <div styleName="marker">
    <span styleName={animated ? 'dot-pulse' : 'dot-static'}></span>
    <span styleName={animated ? 'dot-glow' : 'dot-hidden'}></span>
  </div>

Marker.propTypes = {
  animated: PropTypes.bool,
}

export default CSSModules(Marker, styles)



/** WEBPACK FOOTER **
 ** ./src/components/marker/marker.js
 **/